export default function KingsportFinalCTA() {
  return (
    <section id="contact" className="bg-[#1A365D] py-20 md:py-28 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20industrial%20landscape%20view%20of%20Kingsport%20Tennessee%20showing%20the%20Holston%20River%20winding%20through%20the%20city%20with%20Eastman%20Chemical%20campus%20visible%20below%20the%20Appalachian%20ridgelines%20at%20golden%20hour%2C%20wide%20editorial%20photograph%20over%20Sullivan%20County%20Northeast%20Tennessee&width=1600&height=700&seq=ks-cta-bg-2026&orientation=landscape"
          alt="Kingsport Tennessee Eastman Chemical"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-[#F6C344]/20 text-[#F6C344] text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-full mb-6">
          <i className="ri-briefcase-line"></i>
          Kingsport, TN — Eastman Chemical Passport Specialists
        </div>

        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white leading-tight mb-6">
          Corporate Travel Ready.
          <br />
          <span className="text-[#F6C344]">Passport Delivered.</span>
        </h2>

        <p className="text-white/70 text-lg leading-relaxed max-w-2xl mx-auto mb-10">
          Eastman Chemical operates in 100+ countries. BAE Systems deploys globally. Your passport needs to keep pace. We eliminate the 100-mile Knoxville drive and the appointment race — delivering corporate-grade passport service right here in Sullivan County.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-14">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center justify-center gap-2 bg-[#F6C344] text-[#1A365D] font-bold text-lg px-10 py-4 rounded-lg hover:bg-[#e5b33f] transition-all whitespace-nowrap"
          >
            <i className="ri-passport-line"></i>
            Start My Application Now
          </a>
          <a
            href="tel:+18888881234"
            className="inline-flex items-center justify-center gap-2 bg-white/10 text-white font-semibold text-lg px-10 py-4 rounded-lg hover:bg-white/20 transition-all border border-white/20 whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            Corporate Emergency Line
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto mb-12">
          <div className="bg-white/10 rounded-xl p-6 text-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344]/20 mx-auto mb-3">
              <i className="ri-flashlight-line text-[#F6C344] text-xl"></i>
            </div>
            <h4 className="font-bold text-white text-lg mb-1">24–48 Hours</h4>
            <p className="text-white/60 text-xs">Emergency corporate processing for urgent overseas assignments</p>
          </div>
          <div className="bg-white/10 rounded-xl p-6 text-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344]/20 mx-auto mb-3">
              <i className="ri-flask-line text-[#F6C344] text-xl"></i>
            </div>
            <h4 className="font-bold text-white text-lg mb-1">Eastman Ready</h4>
            <p className="text-white/60 text-xs">Corporate priority processing for chemical industry professionals</p>
          </div>
          <div className="bg-white/10 rounded-xl p-6 text-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344]/20 mx-auto mb-3">
              <i className="ri-route-line text-[#F6C344] text-xl"></i>
            </div>
            <h4 className="font-bold text-white text-lg mb-1">Zero Drive</h4>
            <p className="text-white/60 text-xs">100-mile Knoxville agency trip completely eliminated</p>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 text-white/50 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-check-double-line text-[#F6C344]"></i>
            <span>No Appointment Required</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-double-line text-[#F6C344]"></i>
            <span>Corporate Document Review Included</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-double-line text-[#F6C344]"></i>
            <span>Overnight Delivery to Kingsport</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-double-line text-[#F6C344]"></i>
            <span>24/7 Corporate Emergency Support</span>
          </div>
        </div>
      </div>
    </section>
  );
}